type NavigationListener = () => void;

const listeners = new Set<NavigationListener>();

function normalizePathname(pathname: string) {
  if (pathname.length > 1 && !pathname.endsWith("/")) {
    return `${pathname}/`;
  }
  return pathname;
}

export function hrefLeavesPage(href: string, currentHref: string): boolean {
  try {
    const current = new URL(currentHref);
    const next = new URL(href, currentHref);
    if (next.origin !== current.origin) return true;

    return (
      normalizePathname(next.pathname) !== normalizePathname(current.pathname) ||
      next.search !== current.search
    );
  } catch {
    return false;
  }
}

export function elementLeavesPage(element: Element | null): boolean {
  const anchor = element?.closest("a");
  if (!anchor || anchor.getAttribute("target") === "_blank" || anchor.hasAttribute("download")) {
    return false;
  }

  const href = anchor.getAttribute("href");
  if (!href || /^(#|mailto:|tel:|javascript:)/i.test(href)) return false;

  return hrefLeavesPage(href, window.location.href);
}

export function notifyNavigationStarted() {
  listeners.forEach((listener) => listener());
}

export function subscribeNavigationStarted(listener: NavigationListener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
